"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitTypeTitle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@yanzi/react-ui");
function UnitTypeTitle(_a) {
    var { isSelected } = _a, props = __rest(_a, ["isSelected"]);
    return (jsx_runtime_1.jsx(react_ui_1.Button, Object.assign({ fontWeight: "bold", py: 1, px: 1, borderRadius: 3, color: isSelected ? 'accentBackgroundedText' : 'inherit', backgroundColor: isSelected ? 'accent' : 'transparent' }, props), void 0));
}
exports.UnitTypeTitle = UnitTypeTitle;
//# sourceMappingURL=UnitTypeTitle.js.map